'use client';
import { useAdaptFileUrl } from '@unifyapps/network/hooks/useAdaptFileUrl';
import DOMPurify from 'dompurify';
import type { SVGProps } from 'react';
import InlineSVG from 'react-inlinesvg';

// Runs once per unique SVG payload
// react-inlinesvg caches requests and memoizes preProcessor output via `cacheRequests`.
function preProcess(raw: string) {
  const clean = DOMPurify.sanitize(raw, {
    USE_PROFILES: { svg: true, svgFilters: true },
    ADD_TAGS: ['use'], // use tags are used in some the app icons in workflow builder
  });

  return clean;
}

export function createCustomIcon(iconName: string) {
  return function CustomIcon(props: SVGProps<SVGSVGElement>) {
    const adaptFileUrl = useAdaptFileUrl();
    // InlineSVG overloads onLoad/onError with its own callback signatures
    // (hasCache flag, ErrorCallback) that conflict with the native SVG
    // handlers on SVGProps — strip them from the pass-through.
    const { onLoad: _onLoad, onError: _onError, ...rest } = props;
    return (
      <InlineSVG cacheRequests preProcessor={preProcess} src={adaptFileUrl(iconName)} {...rest} />
    );
  };
}
